/**
 * Created by Administrador on 22/08/2019.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('flightTracking', {
                parent: 'app',
                url: '/flightTracking?flightDate&flightIdConnectionId&status&isFlight&page&size',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                params: {
                    flightDate: null,
                    flightIdConnectionId: "0",
                    status: "FLIGHT",
                    isFlight: "true",
                    page: "0",
                    size: "10"
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/auditRegistration/flightTracking/flightTracking.html',
                        controller: 'flightTrackingCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['flightTracking']);
                            }],
                            tabs: ['tabService', '$stateParams', function (tabService, $stateParams) {
                                if ($stateParams.flightDate == null) {
                                    $stateParams.flightDate = (new Date()).getTime();
                                }
                                return tabService.getTabAuditRegistration('flightTracking')
                            }]
                        }
                    }
                }
            })
            .state('revenueTracking', {
                parent: 'app',
                url: '/revenueTracking?flightDate&flightIdConnectionId&status&isFlight&page&size',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                params: {
                    flightDate: null,
                    flightIdConnectionId: "0",
                    status: "REVENUE",
                    isFlight: "true",
                    page: "0",
                    size: "10"
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/auditRegistration/flightTracking/flightTracking.html',
                        controller: 'flightTrackingCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['flightTracking']);
                            }],
                            tabs: ['tabService', '$stateParams', function (tabService, $stateParams) {
                                if ($stateParams.flightDate == null) {
                                    $stateParams.flightDate = (new Date()).getTime();
                                }
                                return tabService.getTabAuditRegistration('revenueTracking')
                            }]
                        }
                    }
                }
            })
            .state('flightTrackingDetail', {
                parent: 'app',
                url: '/flightTracking/:id/detail?date&route&flightNumber',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                params: {
                    date: "",
                    route: "",
                    flightNumber: ""
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/auditRegistration/flightTracking/flightTrackingDetail.html',
                        controller: 'flightTrackingDetailCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['flightTracking', 'adminFlight']);
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabAuditRegistration('flightTracking')
                            }],
                            flightTrackingDetail:['$stateParams', 'flightTrackingService',function($stateParams, flightTrackingService){
                                return flightTrackingService.getAuditLogById($stateParams.id);
                            }]
                        }
                    }
                }
            })
            .state('flightTrackingDetailConnection', {
                parent: 'app',
                url: '/flightTracking/:id/detailConnection?date&route&flightNumber',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                params: {
                    date: "",
                    route: "",
                    flightNumber: ""
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/auditRegistration/flightTracking/flightTrackingDetailConnection.html',
                        controller: 'flightTrackingDetailConnectionCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['flightTracking', 'adminConnection']);
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabAuditRegistration('flightTracking')
                            }],
                            flightTrackingDetail:['$stateParams', 'flightTrackingService',function($stateParams, flightTrackingService){
                                return flightTrackingService.getAuditLogById($stateParams.id);
                            }]
                        }
                    }
                }
            })
            .state('revenueTrackingDetail', {
                parent: 'app',
                url: '/revenueTracking/:id/detail?date&route&flightNumber',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                params: {
                    date: "",
                    route: "",
                    flightNumber: ""
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/auditRegistration/flightTracking/revenueTrackingDetail.html',
                        controller: 'revenueTrackingDetailCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['flightTracking', 'revenuePlanning']);
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabAuditRegistration('revenueTracking')
                            }],
                            categories: ['tariffClassService',function(tariffClassService){
                                return tariffClassService.getFareClassesFare();
                            }],
                            flightTrackingDetail:['$stateParams', 'flightTrackingService',function($stateParams, flightTrackingService){
                                return flightTrackingService.getAuditLogById($stateParams.id);
                            }]
                        }
                    }
                }
            })
            .state('revenueTrackingDetailConnection', {
                parent: 'app',
                url: '/revenueTracking/:id/detailConnection?date&route&flightNumber',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                params: {
                    date: "",
                    route: "",
                    flightNumber: ""
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/auditRegistration/flightTracking/revenueTrackingDetailConnection.html',
                        controller: 'revenueTrackingDetailConnectionCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['flightTracking', 'revenuePlanning']);
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabAuditRegistration('flightTracking')
                            }],
                            flightTrackingDetail:['$stateParams', 'flightTrackingService',function($stateParams, flightTrackingService){
                                return flightTrackingService.getAuditLogById($stateParams.id);
                            }]
                        }
                    }
                }
            });
    }
})();
